import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PublicAccessContext = createContext();

export const usePublicAccess = () => {
  const context = useContext(PublicAccessContext);
  if (!context) {
    throw new Error('usePublicAccess must be used within a PublicAccessProvider');
  }
  return context;
};

export const PublicAccessProvider = ({ children }) => {
  const [publicCategories, setPublicCategories] = useState([]);
  const [showLoginPrompt, setShowLoginPrompt] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPublicCategories();
  }, []);

  const fetchPublicCategories = async () => {
    try {
      const response = await axios.get(`${API}/admin/public-categories`);
      setPublicCategories(response.data.public_categories || []);
      setShowLoginPrompt(response.data.show_login_prompt ?? true);
    } catch (error) {
      console.error('Error fetching public categories:', error);
      // Default to common public categories
      setPublicCategories([
        { id: 'forums', name: 'Forums', route: '/forums' },
        { id: 'breeds', name: 'Breeds', route: '/breeds' },
        { id: 'services', name: 'Services', route: '/services' },
        { id: 'dog_parks', name: 'Dog Parks', route: '/parks' },
        { id: 'events', name: 'Events', route: '/events' },
        { id: 'organizations', name: 'Organizations', route: '/organizations' },
        { id: 'health_info', name: 'Health', route: '/health' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const isCategoryPublic = (categoryId) => {
    return publicCategories.some(cat => cat.id === categoryId);
  };

  const isRoutePublic = (route) => {
    return publicCategories.some(cat => cat.route === route || route.startsWith(cat.route + '/'));
  };

  const value = {
    publicCategories,
    showLoginPrompt,
    loading,
    isCategoryPublic,
    isRoutePublic,
    refreshCategories: fetchPublicCategories
  };

  return (
    <PublicAccessContext.Provider value={value}>
      {children}
    </PublicAccessContext.Provider>
  );
};

export default PublicAccessContext;
